import React, {useRef, useState} from 'react';
import * as R from 'ramda';
import { ReactMultiEmail } from "react-multi-email";
import {shareDocuments} from '../../actions/facilita-api';
import "react-multi-email/style.css";
import { useDispatch } from 'react-redux';
import * as loadings from '../../constants/loadings/facilita/deathDeclaration';
import {ToasterConfigurations} from '../../constants/toasterText/configurations';
import $ from 'jquery';
import { toast } from 'react-toastify';

export const ModalPartager = ({fileNames, userId, userRepresentativeId, isLoading }) => {
	const dispatch = useDispatch();
	const formRef = useRef();
	const [emailAddresses, setEmailAddresses] = useState([]);

	return (
		<div className="modal fade px-0" id="partager" aria-labelledby="partagerLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-sm">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-info rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Share docs</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-info text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="partagerLabel">Partager document</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close" onClick={() => {setEmailAddresses([]);}} >
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default pt-0">
						<p className="h5 lh-copy mb-gutter o-60">Veuillez renseigner les adresses e-mail des personnes avec qui vous souhaitez partager {fileNames.length > 1 ? 'les ' + fileNames.length + ' documents' : 'le document'}.</p>

						<form className="block" noValidate ref={formRef}>
							<hr className="mt-0 mb-4" />
							<div className="form-row text-left">
								<div className="col-lg form-group">
									<label className="h6 font-weight-bolder" htmlFor="email">E-mail</label>

									<ReactMultiEmail
										placeholder="utilisateuremail@mail.fr"
										emails={emailAddresses}
										onChange={(emails) => {
											setEmailAddresses(emails);
										}}
										getLabel={(email, index) => {
											return (<div data-tag key={index}>
												{email}
												<span data-tag-handle onClick={() => setEmailAddresses(emailAddresses.filter(e => e !== email))}>
												×
												</span>
											</div>)
										}}
										/>
									{/* <p className="h6 lh-copy mb-auto o-60">Vous pouvez renseigner plus d'une adresse séparée par un ';'</p> */}
									<div className={"invalid-feedback alert alert-danger"}>
										Adresse e-mail invalide
									</div>
								</div>
								{/* <div className="col col-lg-4 form-group">
									<label className="h6 font-weight-bolder" htmlFor="role">Permission</label>
									<select className="form-control custom-select" id="role" aria-label="Default select example">
										<option selected>Choose permissions...</option>
										<option value="Viewer">Viewer</option>
									</select>
								</div> */}
							</div>
						</form>
					</div>
					<div className="modal-footer pt-0">
						<button type="button" className="btn btn-faded" data-dismiss="modal">Annuler</button>
						{
							isLoading.includes(loadings.SHARING_FILES) ?
								<button type="button" className="btn btn-info loading-btn show"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Enregistrer</button>
							:
								<button type="button" className="btn btn-info" onClick={(e) => {
									if(!R.isEmpty(emailAddresses)){
										e.preventDefault();
										if(formRef.current.checkValidity()){
											dispatch(shareDocuments(userId, emailAddresses, fileNames, userRepresentativeId))
											.then(() => $('.modal').modal("hide"))
											.then(() => {
												toast.success("Les documents ont été partagés.", ToasterConfigurations);
												setEmailAddresses([]);
											})
											.catch(() => {
												toast.error("Une erreur est survenue.", ToasterConfigurations);
												setEmailAddresses([]);
											})
										}
										formRef.current.classList.add('was-validated');
									}
								}}>Enregistrer</button>

						}

					</div>
				</div>
			</div>
		</div>
	)
}